import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_SUMMARY_REPORT_OBJECTS: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_OBJECTS"),
    GET_SUMMARY_REPORT_OBJECTS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_OBJECTS_COMPLETED"),
    GET_SUMMARY_REPORT_OBJECTS_REJECTED: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_OBJECTS_REJECTED"),
    GET_SUMMARY_REPORT_OBJECT: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_OBJECT"),
    GET_SUMMARY_REPORT_OBJECT_COMPLETED: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_OBJECT_COMPLETED"),
    GET_SUMMARY_REPORT_OBJECT_REJECTED: createActionType(FULL_NAMESPACE, "GET_SUMMARY_REPORT_OBJECT_REJECTED"),
    CLEAR_DATA: createActionType(FULL_NAMESPACE, "CLEAR_DATA"),
    SET_SUMMARY_REPORT_OBJECTS: createActionType(FULL_NAMESPACE, "SET_SUMMARY_REPORT_OBJECTS")
};
